exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-grid-tile-footer, .card-footer{\n  background:#00823C;\n}\n\n.mat-grid-list { margin: 8px; }\n\n\n.mat-grid-tile{\n    cursor: pointer;\n    box-shadow: 3px 3px 6px -3px rgba(0,0,0,0.75);\n    border: 1px solid rgb(172, 172, 172);\n}\n.layer-grid-container{\n    top:59px;\n    position: absolute;\n    height: calc(100% - 59px);\n    width: 100%;\n    overflow-y: auto;\n}\nimg {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    overflow: hidden;\n}\n\n.loading-spinner {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  height: 80vh;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/jenkins-agent/workspaces/workspace/enmapa-gis-mob-frontend/src/app/components/layer-grid/layer-grid.component.css
// module id = ../../../../../src/app/components/layer-grid/layer-grid.component.css
// module chunks = main